module.exports = __webpack_public_path__ + "img/shahnawaz-pro.33ba995d.jpg";